<template>
  <button type="button" class="mode-option" @click="handleSelect">
    <span class="mode-option__icon" :class="`mode-option__icon--${mode}`">
      <v-icon class="mode-option__glyph" :class="`mode-option__glyph--${mode}`">
        {{ icon }}
      </v-icon>
    </span>

    <span class="mode-option__copy">
      <span class="mode-option__title">
        {{ title }}
      </span>
      <span class="mode-option__description">
        {{ description }}
      </span>
    </span>

    <v-icon class="mode-option__chevron">
      {{ chevronIcon }}
    </v-icon>
  </button>
</template>

<script>
import { mdiChevronLeft, mdiChevronRight } from '@mdi/js'

export default {
  name: 'AssessmentModeOptionCard',
  props: {
    description: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  emits: ['select'],
  data() {
    return {
      mdiChevronLeft,
      mdiChevronRight,
    }
  },
  computed: {
    chevronIcon() {
      return this.$vuetify.rtl ? this.mdiChevronLeft : this.mdiChevronRight
    },
  },
  methods: {
    handleSelect() {
      this.$emit('select', this.mode)
    },
  },
}
</script>

<style scoped>
.mode-option {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 14px;
  padding: 14px 18px;
  border: 0;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 8px 20px rgba(22, 50, 66, 0.08);
  cursor: pointer;
  text-align: start;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.mode-option:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 24px rgba(22, 50, 66, 0.1);
}

.mode-option__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  margin-inline-end: 14px;
  border-radius: 10px;
}

.mode-option__icon--guided {
  background: #e8ecff;
}

.mode-option__icon--voice {
  background: #dcfff7;
}

.mode-option__icon--text {
  background: #fde6ff;
}

.mode-option__glyph {
  font-size: 20px;
}

.mode-option__glyph--guided {
  color: #4d67ff;
}

.mode-option__glyph--voice {
  color: #09b8a6;
}

.mode-option__glyph--text {
  color: #d14dff;
}

.mode-option__copy {
  flex: 1;
  min-width: 0;
}

.mode-option__chevron {
  color: #9aa8cc;
  font-size: 18px;
}

.mode-option__title {
  display: block;
  margin-bottom: 2px;
  color: #173149;
  font-size: 1.1rem;
  font-weight: 700;
  line-height: 1.25;
}

.mode-option__description {
  display: block;
  color: #7a87b0;
  font-size: 0.97rem;
  line-height: 1.35;
}

@media screen and (max-width: 600px) {
  .mode-option {
    padding: 14px 16px;
  }
}
</style>
